module.exports = __webpack_public_path__ + "static/media/web development.a15fb4ae.svg";